"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {
            paddingTop: theme.spacing(2),
        },
        header: {
            margin: "".concat(theme.spacing(2), "px 0"),
            textAlign: 'center',
        },
        title: {
            padding: 0,
            fontWeight: 400,
            margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(1), "px 0"),
        },
        subtitle: {},
        field: {
            margin: "".concat(theme.spacing(2), "px 0"),
        },
        error: {
            color: theme.palette.error.main,
        },
        footer: {
            margin: "".concat(theme.spacing(2), "px 0"),
            textAlign: 'center',
        },
    });
});
